import { AxiosRequest } from "../../../Url";
import { getRightsData } from "../../Tools/Tools";
import { parseColumns } from "../GridTools/parseColumnTools";
import { createGrid, createRecordSource } from "../rcsgrid";
import { getTableLayout } from "../../Tools/Requests";

export async function accountsTableGrid(grid: createGrid, source: createRecordSource, props, data) {
  const json = await getTableLayout({ module: props.Module, path: props.Path });
  source.onHandleRequest = handleRequest(props, source);

  if (json) {
    source.rights = getRightsData(json.Rights);

    grid.setColumns(
      parseColumns(json, {
        Path: props.Path,
        Module: props.Module,
      }),
    );
  } else grid.defaultColumns = true;

  await source.open();
  if (data.setSelectedRecord) {
    source.onRecordIndexChanged = async function (source) {
      data.setSelectedRecord(source.getFieldTextSync("ID"));
    };
    data.setSelectedRecord(source.getFieldTextSync("ID"));
  }
  if (data.onMultiSelectChange) {
    grid.onMultiSelectChange = function () {
      data.onMultiSelectChange();
    };
  }
  //   if (!props.ObjRef) source.refresh();
  await grid.setSource(source);
  //   if (props.ObjRef) grid.refreshSource(props.ObjRef);
  await grid.updateGridSize();
}

function handleRequest(props, source) {
  return (request) => {
    const params = new Map();
    params.set("prefix", props.Module).set("comand", "HandleTable").set("Path", props.Path);
    return AxiosRequest(true, params, request);
  };
}
